// Parsing de dates propi del portal mòbil.
//
// El backend retorna DATETIME com "YYYY-MM-DD HH:MM:SS" (hora local del
// servidor). `new Date("YYYY-MM-DD HH:MM:SS")` (amb espai en lloc de "T")
// té un comportament no estàndard i Safari/iOS sovint el rebutja
// ("Invalid Date"). Com que aquest portal és sobretot per a mòbil, no ens
// podem permetre confiar-hi: aquí es parseja manualment component a
// component amb el constructor `new Date(any, mes, dia, h, m, s)`, que és
// sempre hora local i idèntic a tots els navegadors.

export function chParseDataHoraLocal(dataHoraStr) {
  if (!dataHoraStr) return null;
  const [dataPart, horaPart] = dataHoraStr.includes("T") ? dataHoraStr.split("T") : dataHoraStr.split(" ");
  const [any, mes, dia] = (dataPart || "").split("-").map(Number);
  const [h, m, s] = (horaPart || "0:0:0").split(":").map(Number);
  if (!any || !mes || !dia) return null;
  return new Date(any, mes - 1, dia, h || 0, m || 0, s || 0);
}

// "HH:MM" directe per substring, sense passar per Date (encara més robust
// per mostrar només l'hora d'un event).
export function chFormatHora(dataHoraStr) {
  if (!dataHoraStr) return "--";
  const horaPart = dataHoraStr.includes("T") ? dataHoraStr.split("T")[1] : dataHoraStr.split(" ")[1];
  if (!horaPart) return "--";
  return horaPart.slice(0, 5);
}
